import React from 'react';
import PropTypes from 'prop-types';

import {
    StatusBadge,
    SCORE_UPDATE_SHAPE,
    PERIOD_EVENT_SHAPE
} from './StatusBadge';

/**
 * The Desktop (row) layout's center group: `score · StatusBadge · score`.
 *
 * @param {object} props - Props.
 * @param {object} props.match - The normalised match object from useMatchCardData.
 * @param {string} props.genericStatus - One of PULSE.app.common.CONSTANTS.MATCH_STATUS.
 * @param {string} props.matchId - The match's providerId.
 * @param {object} [props.scoreUpdate] - { show, team: 'home'|'away', type } from useScoreUpdate.
 * @param {object} [props.periodEvent] - { show, period, phase } from usePeriodEvent.
 * @returns {React.ReactElement} The score group.
 */
export const ScoreGroup = ({
    match,
    genericStatus,
    matchId,
    scoreUpdate,
    periodEvent
}) => {
    return (
        <>
            <span className="label-l-semi-bold text-on-surface-variant">
                {match.homeScore ?? '–'}
            </span>
            <StatusBadge
                match={match}
                genericStatus={genericStatus}
                matchId={matchId}
                scoreUpdate={scoreUpdate}
                periodEvent={periodEvent}
            />
            <span className="label-l-semi-bold text-on-surface-variant">
                {match.awayScore ?? '–'}
            </span>
        </>
    );
};

ScoreGroup.propTypes = {
    match: PropTypes.object.isRequired,
    genericStatus: PropTypes.string.isRequired,
    isPlaceholder: PropTypes.bool,
    matchId: PropTypes.string.isRequired,
    scoreUpdate: SCORE_UPDATE_SHAPE,
    periodEvent: PERIOD_EVENT_SHAPE
};
